export default "__VITE_ASSET__3292baf3__"